<ion-header no-border>
    <ion-toolbar class="ion-text-center">
        <ion-title>GrowCoCo Chat</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="dismissModal()">
                <ion-icon name="close-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list #chatList class="chat-list no-bg" lines="none">
        <ion-item *ngFor="let chat of chatMsgs">
            <div class="chat-bubble" [class.own]="chat.uuid == uuid">
                <p class="chat-message">{{chat.msg}}<br>
                    <span class="chat-date">{{chat.author}} - {{chat.dateCreated | date:'MMM d h:m'}}</span>
                </p>
            </div>
        </ion-item>
    </ion-list>
</ion-content>

<ion-footer>
    <div class="content">
        <ion-toolbar class="footer-toolbar">
            <ion-textarea spellcheck="true" autoComplete="true" autocorrect="true" rows="1" class="chat-input"
                          [(ngModel)]="message" placeholder="type message..." (keyup.enter)="addChat()"
                          (keydown.enter)="preventDefault($event)">
            </ion-textarea>
            <ion-buttons slot="primary">
                <ion-button (click)="changeUserName()" slot="end">
                    {{userName}}
                </ion-button>
                <ion-button [disabled]="!(message.length > 0)" (click)="addChat()" slot="end" class="send-chat-button">
                    <ion-icon slot="icon-only" name="send"></ion-icon>
                </ion-button>
            </ion-buttons>
        </ion-toolbar>
    </div>
</ion-footer>
